import { Box } from '@chakra-ui/layout'
import { Text } from '@chakra-ui/react'
import _ from 'lodash'
import { type APIUser } from '../api'

interface PoiInfoProps {
  user: APIUser
}
const PoiInfo = ({ user }: PoiInfoProps) => {
  return (
    <Box>
      <Text style={{ fontSize: '20px' }} pt={'46px'} isTruncated>
        {_.get(user, 'poiName')}
      </Text>
      <Text isTruncated>
        {`${_.get(user, 'address', '')}, ${_.get(user, 'postalCode', '')} ${_.get(
          user,
          'city',
          ''
        )},${_.get(user, 'state', '')} ${_.get(user, 'country', '')}`}
      </Text>
    </Box>
  )
}

export default PoiInfo
